import { Form } from "antd";
import { TopBox } from "components";
import { LoadingDashboard } from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardParcelUnit } from "service/dashboard/central/parcel";

const UnitParcel = () => {
  const { t } = useTranslation();

  const { findDate, property } = useOverview();

  const unitParcelDate = Form.useWatch("unitParcelDate");
  const date = findDate(unitParcelDate);

  const query = useGetDashboardParcelUnit({ ...date, property });

  return (
    <LoadingDashboard loading={query.isFetching}>
      <TopBox
        query={query}
        keyTitle="unitNumber"
        nameDate="unitParcelDate"
        classNameWrapper="h-[300px]"
        title={t("number-of-unit-with-30-parcels")}
        isCentral
      />
    </LoadingDashboard>
  );
};

export default UnitParcel;
